<aside [ngClass]="{'active': attachmentsService.open, 'inactive': !attachmentsService.open}" id="attachmentAside">
    <div class="dimming" (click)="attachmentsService.open = !attachmentsService.open"></div>

    <div class="panels panel-left attachments attachments-panel Spacebox__lr-small Spacebox__t-small divStyle">

      <header class="Flexbox Flexbox__just-space-around Spacebox__b-regular Spacebox__lr-small Spacebox__t-small panel-title">
        <div class="title fs5 bold">
          <span id="{{'Reports & Documents' | translate}}">{{'Reports & Documents' | translate}}</span>
          <span *ngIf="lists?.length > 0">&nbsp;({{lists.length}})</span>
        </div>
        <span class="close icon__cross" (click)="attachmentsService.open = false"></span>
      </header>

      <div class="attachments-list dropzone-previews">
        <label *ngIf=" !lists || lists?.length === 0 "
               class="attachments-sub-header Marginbox__l-regular Marginbox__t-regular"
               id="{{'Files have not been uploaded for this test yet' | translate}}">
            {{ "ATTACHEMENTS_DEFAULT_TEXT" | translate }}
        </label>

        <div class="lists-wrapper">
          <ul class="files-section others-documents" *ngIf="lists?.length > 0">
            <ng-container *ngFor="let file of lists; trackBy: fileId; let index = index">
              <ng-container *ngIf="(fileSizeErrorMessage && index != 0 || value && index != 0) || (!fileSizeErrorMessage && !value)">
                <li class="attachment Flexbox"
                    [ngClass]="{'active': attachmentsService.activeAction === index +'others',
                                'shared': (file.metaData.shared && file.metaData.shared === 'true')}">

                  <i class="thumb fs6" [ngClass]="findIcon(file.fileType)"></i>
                  <div class="info">
                    <span class="name fs8" *ngIf="file.fileType != 'pdf'" title="{{file.metaData && file.metaData.changeFileName || file.friendlyName}}">
                        {{file.metaData && file.metaData.changeFileName || file.friendlyName}}
                    </span>
                    <span class="name fs8 click" *ngIf="file.fileType == 'pdf'" (click)="viewPdf(file.id, file.friendlyName)"
                          title="{{file.metaData && file.metaData.changeFileName || file.friendlyName}}">
                          {{file.metaData && file.metaData.changeFileName || file.friendlyName}}
                    </span>
                    <small *ngIf="file.actorName" class="actor_name" [ngClass]="{'bold-text': isCommonDoc(file)}">{{getUploadedByText(file)}}</small>
                  </div>

                  <i class="file-icon share-icon fa fa-users" genTooltip
                    [tooltipText]="'File is shared'"
                    [tooltipPosition]="'LEFT'"
                    [tooltipShow]="true">
                  </i>

                  <div class="actions-section-row">
                    <small class="small-date" *ngIf="file.clientDate">{{file.clientDate}} {{file.clientTime}}</small>
                    <small class="small-date" *ngIf="!file.clientDate">{{(file.meta.created || file.meta.lastUpdated) | date:'dd MMM yyyy hh:mm a'}}</small>
                    <div class="attachments-actions-button icon__more_info fs5 scale Auto_Toggle"
                         (click)="attachmentsService.activeAction = attachmentsService.activeAction != index+'others' ? index+'others' : null"></div>
                    <section class="attachments-actions" *ngIf=" attachmentsService.activeAction == index+'others'">
                      <small *ngFor="let action of getActions(file)" class="{{action.class}}" (click)="action.onClick(file)">
                        <i title="{{actionsLabelObject[action.label].text}}" class="fs6 click {{action.icon}}"></i>
                        <span class="action-label">{{actionsLabelObject[action.label].text}}</span>
                      </small>
                    </section>
                  </div>

                </li>
              </ng-container>
            </ng-container>

          </ul>

          <li class="attachment Flexbox" *ngIf="fileSizeErrorMessage || value">
            <small class="thumb">{{apxFileSz}}</small>
            <div class="info">
              <span class="name fs8">{{file.name}} </span>
              <small class="text-danger" *ngIf="fileSizeErrorMessage">{{fileSizeErrorMessage}}</small>
            </div>
            <div class="dz-progress progress progress-striped active" *ngIf="value" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">
              <span class="progress-bar progress-bar-success" id="progress"></span>
            </div>
          </li>

        </div>
      </div>

      <div class="upload" genPermissionSchemaRestrict
            [permissionSchemaKey]="'reportsAndDocsWrite'"
            [nonePermissionAction]="'hide'"
            [nonePermissionOnHideMsg]="'You do not have permissions to uploade files'"
            [nonePermissionOnHideMsgClass]="'Flexbox Flexbox__just-center Flexbox__box-direction-column attachments-sub-header'">
        <div *ngIf="attachmentsService.editModeIsSupported && files?.length < maxUploadedFile">

          <ngx-dropzone [multiple]="false" (change)="onUpload($event)" class="plainBorder">
            <ngx-dropzone-label>
              <span class="arrowContent"><span class="cloudContent">Drag & drop files here</span></span>
              <br>or<span class="txtColor"><br>Select files</span></ngx-dropzone-label>
          </ngx-dropzone>

        </div>
        <span class="Flexbox Flexbox__just-center Flexbox__box-direction-column attachments-sub-header" *ngIf="files?.length >= maxUploadedFile">
          <label> Unable to upload file. </label>
          <label id="max-uploaded-file-count"> You have reached the uploaded files limit ({{maxUploadedFile}} files) for this test. </label>
        </span>
      </div>

    </div>

</aside>

<ng-container *ngIf="attachmentsService.open"></ng-container>
<input style="position: absolute;z-index: 1000000;left: -1000%;" id="attachments-copy-url"/>
